import {ComponentType} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {mr, pb, pl} from "@pg-design/helpers-css";
import {borderRadius} from "@pg-design/helpers-css/";
import {IIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {MIN_VALID_OFFER_OPINION_RESULT} from "./OfferDetailOpinionsResults";

interface Props {
    icon: ComponentType<IIcon>;
    results: number;
    text: string;
}

export const OfferDetailOpinionsResultsItem = (props: Props) => {
    const {icon: Icon, results} = props;

    const isResultsValid = results >= MIN_VALID_OFFER_OPINION_RESULT;

    return isResultsValid ? (
        <div css={wrapper}>
            <div css={iconWrapStyle}>
                <Icon size="3.5" />
            </div>
            <div css={textLineWrapper}>
                <Text variant="info_txt_1">{props.text}</Text>
                <div css={progressWrapper}>
                    <ProgressBar progress={props.results} />
                    <Text as="span">{results}%</Text>
                </div>
            </div>
        </div>
    ) : null;
};

const wrapper = css`
    display: flex;
    flex-direction: row;
    gap: calc(var(--globals-baseUnit) * 2);
`;

const iconWrapStyle = css`
    ${pl(2)};
    ${pb()};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ProgressBar = styled.div<{progress: number}>`
    flex: 1 1 100%;
    position: relative;
    ${borderRadius(3)};
    background-color: var(--colors-gray-400);
    height: 1.2rem;
    ${mr()}

    &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: ${(props) => props.progress}%;
        height: 100%;
        ${borderRadius(3)};
        background-color: var(--colors-primary);
    }
`;

const textLineWrapper = css`
    width: 100%;
`;

const progressWrapper = css`
    display: flex;
    width: 100%;
    align-items: center;
`;
import {ComponentType} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {mr, pb, pl} from "@pg-design/helpers-css";
import {borderRadius} from "@pg-design/helpers-css/";
import {IIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {MIN_VALID_OFFER_OPINION_RESULT} from "./OfferDetailOpinionsResults";

interface Props {
    icon: ComponentType<IIcon>;
    results: number;
    text: string;
}

export const OfferDetailOpinionsResultsItem = (props: Props) => {
    const {icon: Icon, results} = props;

    const isResultsValid = results >= MIN_VALID_OFFER_OPINION_RESULT;

    return isResultsValid ? (
        <div css={wrapper}>
            <div css={iconWrapStyle}>
                <Icon size="3.5" />
            </div>
            <div css={textLineWrapper}>
                <Text variant="info_txt_1">{props.text}</Text>
                <div css={progressWrapper}>
                    <ProgressBar progress={props.results} />
                    <Text as="span">{results}%</Text>
                </div>
            </div>
        </div>
    ) : null;
};

const wrapper = css`
    display: flex;
    flex-direction: row;
    gap: calc(var(--globals-baseUnit) * 2);
`;

const iconWrapStyle = css`
    ${pl(2)};
    ${pb()};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ProgressBar = styled.div<{progress: number}>`
    flex: 1 1 100%;
    position: relative;
    ${borderRadius(3)};
    background-color: var(--colors-gray-400);
    height: 1.2rem;
    ${mr()}

    &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: ${(props) => props.progress}%;
        height: 100%;
        ${borderRadius(3)};
        background-color: var(--colors-primary);
    }
`;

const textLineWrapper = css`
    width: 100%;
`;

const progressWrapper = css`
    display: flex;
    width: 100%;
    align-items: center;
`;
